import React from 'react'
import { RegistrationList } from 'features/registration/registration-list'

export default function RegistrationListPage() {
  return <RegistrationList />
}
